var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"gl_title_bar marginBottom10"},[_c('div',{staticClass:"gl_tb_left"},[_c('span',{staticClass:"normaltitle"},[_vm._v("我的论文")])])])])
}]

export { render, staticRenderFns }